<template>
  <div class="invoice-apply-page">
    <a-card title="批量申请发票" :bordered="false">
      <a-form-model :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 14 }">
        <a-form-model-item label="抬头类型">
          <a-radio-group v-model="form.titleType">
            <a-radio value="person">个人</a-radio>
            <a-radio value="company">企业单位</a-radio>            
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="发票抬头">
          <a-input
            v-model="form.title"
            placeholder="请输入发票抬头"
            :disabled="form.titleType === 'person'"
          />
        </a-form-model-item>

        <a-form-model-item label="税号" v-if="form.titleType === 'company'">
          <a-input v-model="form.taxNo" placeholder="请输入税号" />
        </a-form-model-item>

        <a-form-model-item label="收票邮箱">
          <a-input v-model="form.email" placeholder="请输入收票邮箱" />
        </a-form-model-item>

        <a-form-model-item label="开票项目">
          <a-select
            v-model="form.itemCodeSelected"
            placeholder="请选择开票项目"
            @change="onItemSelect"
            style="width: 100%"
          >
            <a-select-option
              v-for="(opt, idx) in itemOptions"
              :key="idx"
              :value="opt.value"
            >
              {{ opt.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item label="发票备注">
          <a-input v-model="form.remark" placeholder="选填" />
        </a-form-model-item>
      </a-form-model>

      <div class="selected-box">
        <div class="title">已选记录（{{ orderRows.length }}）</div>
        <a-table
          :columns="orderColumns"
          :data-source="orderRows"
          :pagination="false"
          :row-key="row => row.orderId"
          size="small"
        />
        <div class="sum" v-if="totalAmount">合计金额：&yen;{{ totalAmount }}</div>
      </div>

      <div class="actions">
        <a-button class="btn-cancel" @click="goBack">取消</a-button>
        <a-button class="btn" type="primary" :loading="submitting" @click="submitApply">提交申请</a-button>
      </div>
    </a-card>
  </div>
</template>

<script>
import { ajaxGetDictItems, getDictItemsFromCache } from '@/api/api'

export default {
  name: 'StudentInvoiceApply',
  data() {
    return {
      submitting: false,
      orderIds: [],
      orderRows: [],
      totalAmount: '',
      studentInfo: null,
      itemOptions: [],
      form: {
        titleType: 'person',
        title: '',
        taxNo: '',
        email: '',
        itemCodeSelected: '',
        itemCode: '',
        itemText: '',
        remark: '',
      },
      orderColumns: [
        { title: '单据号', dataIndex: 'tradeNo', align: 'center', width: 130 },
        { title: '缴费时间', dataIndex: 'orderTime', align: 'center', width: 160 },
        { title: '支付方式', dataIndex: 'tradeChannel', align: 'center', width: 100 },
        { title: '金额', dataIndex: 'amount', align: 'center', width: 100 },
        
      ],
    }
  },
  watch: {
    'form.titleType': function (val) {
      if (val === 'person') {
        this.form.title = this.studentInfo && this.studentInfo.name || ''
      } else {
        this.form.title = ''
      }
    },
  },
  created() {
    const idsText = (this.$route.query.orderIds || '').trim()
    if (!idsText) {
      this.$message.error('未选择订单')
      this.goBack()
      return
    }
    this.orderIds = idsText.split(',').filter(Boolean)

    // 从 sessionStorage 获取列表页传递的订单明细
    const stored = sessionStorage.getItem('invoice_apply_orders')
    if (stored) {
      try {
        const orders = JSON.parse(stored)
        this.orderRows = orders.filter(o => this.orderIds.includes(o.orderId))
        const sum = this.orderRows.reduce((s, o) => s + (Number(o.amount) || 0), 0)
        this.totalAmount = sum.toFixed(2)
      } catch (e) {
        console.error('解析订单明细失败', e)
      }
      sessionStorage.removeItem('invoice_apply_orders')
    }

    this.loadStudentInfo()
    this.initItemDict()
  },
  methods: {
    goBack() {
      this.$router.push('/personalcenters/invoice/list')
    },
    loadStudentInfo() {
      const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
      this.studentInfo = userInfo
      if (userInfo.email) {
        this.form.email = userInfo.email
      }
      if (this.form.titleType === 'person') {
        this.form.title = userInfo.name || ''
      }
    },
    initItemDict() {
      const dict = getDictItemsFromCache('invoice_item')
      if (dict) {
        this.buildItemOptions(dict)
        return
      }
      ajaxGetDictItems('invoice_item', null).then((res) => {
        if (res.success) {
          let data = res.result
          if (data.records) data = data.records
          this.buildItemOptions(data || [])
        }
      })
    },
    buildItemOptions(dictData) {
      this.itemOptions = (dictData || []).map((item) => ({
        value: item.text || item.label,   // 用text做value，避免重复
        label: item.text || item.label,   // 显示文本
        origValue: item.value,            // 原始字典value，提交时使用
      }))
    },
    onItemSelect(val) {
      const opt = this.itemOptions.find((o) => o.value === val)
      if (opt) {
        this.form.itemText = opt.label
        this.form.itemCode = opt.origValue
      } else {
        this.form.itemText = ''
        this.form.itemCode = ''
      }
    },
    submitApply() {
      if (!this.form.title) {
        this.$message.error('请输入发票抬头')
        return
      }
      if (!this.form.email) {
        this.$message.error('请输入收票邮箱')
        return
      }
      if (this.form.titleType === 'company' && !this.form.taxNo) {
        this.$message.error('请输入税号')
        return
      }
      if (!this.form.itemCodeSelected) {
        this.$message.error('请选择开票项目')
        return
      }

      const payload = {
        orderIds: this.orderIds,
        titleType: this.form.titleType,
        title: this.form.title,
        taxNo: this.form.taxNo,
        email: this.form.email,
        itemCode: this.form.itemCode,
        itemText: this.form.itemText,
        remark: this.form.remark,
      }
      this.submitting = true
      this.axios
        .post('/stu/invoice/applyBatch', payload)
        .then((res) => {
          if (res.code === 200) {
            this.$message.success(res.message || '提交成功')
            this.goBack()
          } else {
            this.$message.error(res.message || '提交失败')
          }
        })
        .finally(() => {
          this.submitting = false
        })
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'

.btn {
  background: $bgColor !important;
  border: none;
}

.btn-cancel {
  margin-right: 12px;
}

.invoice-apply-page
  background $bgcontent
  min-height 600px
  padding 20px

.selected-box
  margin-top 20px
  .title
    margin-bottom 10px
    font-weight 600
  .sum
    text-align right
    margin-top 10px
    font-size 16px
    color $bgColor

.actions
  margin-top 20px
</style>




// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/StudentInvoiceApply.vue